import { render, staticRenderFns } from "./videoControlList.vue?vue&type=template&id=2d1f0ab3&scoped=true"
import script from "./videoControlList.vue?vue&type=script&lang=js"
export * from "./videoControlList.vue?vue&type=script&lang=js"
import style0 from "./videoControlList.vue?vue&type=style&index=0&id=2d1f0ab3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1f0ab3",
  null
  
)

export default component.exports